import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { setAuthGateUrl, setClientId, setCookieDomain, setEnv, setResetPasswordRedirect, setUseCheggMfaToken } from "../utils/config";
// unsure why this doesnt work with aliases. leaving as is <arieh@chegg.com>
import { Environment } from "../utils/config";
import { getCookie } from "../utils/cookieManager";
import { refreshToken } from "./refreshToken";
import { checkRefresh, setTokens } from "./setTokens";
import { initBroadCastListener } from "../utils/broadcastListeners";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
import { resetClient } from "../utils/gqlClient";

//@ts-ignore
import packageJson from "../../package.json";
var version = packageJson.version;
export { init, setShouldUseCheggMfaToken };
var defaultParams = {
  env: Environment.prod,
  clientId: 'CHGG',
  refreshOnStart: true
};
async function init(params) {
  sendNewRelicEvent({
    EventName: 'init',
    version: version
  });
  if (typeof window !== 'undefined') {
    /* istanbul ignore next */
    window.addEventListener('online', function () {
      return checkRefresh();
    });
  }
  var _defaultParams$params = _objectSpread(_objectSpread({}, defaultParams), params),
    env = _defaultParams$params.env,
    domainUrl = _defaultParams$params.domainUrl,
    cookieDomain = _defaultParams$params.cookieDomain,
    clientId = _defaultParams$params.clientId,
    refreshOnStart = _defaultParams$params.refreshOnStart,
    resetPasswordSuccessRedirect = _defaultParams$params.resetPasswordSuccessRedirect,
    authGateUrl = _defaultParams$params.authGateUrl,
    useCheggMfaToken = _defaultParams$params.useCheggMfaToken;
  setEnv(env);
  if (resetPasswordSuccessRedirect) {
    setResetPasswordRedirect(resetPasswordSuccessRedirect);
  }
  var cDomain = cookieDomain || domainUrl;

  /* istanbul ignore else */
  if (env == Environment.test && domainUrl) {
    console.warn('`domainUrl` parameter is deprecated - please use `cookieDomain` instead');
  }
  if (cDomain) {
    setCookieDomain(cDomain);
  }
  if (authGateUrl) {
    setAuthGateUrl(authGateUrl);
  }
  setUseCheggMfaToken(!!useCheggMfaToken);
  setClientId(clientId);
  var idToken = getCookie('id_token');
  var accessToken = getCookie('access_token');
  initBroadCastListener();
  if (idToken && accessToken) {
    await setTokens({
      idToken: idToken,
      accessToken: accessToken,
      callInitSession: false
    });
    return;
  }
  if (idToken && refreshOnStart) {
    await refreshToken();
  }
}
function setShouldUseCheggMfaToken(flag) {
  resetClient();
  setUseCheggMfaToken(!!flag);
}